module.exports = __webpack_public_path__ + "static/2-a25dd7932b65b5cbd7cf69dbf017c563.jpg";